import React, { useContext } from "react";
import { Dropdown } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";

import { getTranslation, LanguageContext } from "../languageProvider";
import { firebaseLanguageSetup } from "../../firebase";

export const SwitchLanguage = React.memo(({ login }) => {
  const { lang, setLang } = useContext(LanguageContext);

  const options = [
    {
      key: "pt",
      value: "pt",
      text: (
        <span data-translate="0006">
          <i className="pt flag"></i> {getTranslation("0006")}
        </span>
      ),
    },
    {
      key: "en",
      value: "en",
      text: (
        <span data-translate="0005">
          <i className="gb flag"></i> {getTranslation("0005")}
        </span>
      ),
    },
  ];
  return (
    <div className={login ? "loginSwitchLanguage" : ""}>
      <Dropdown
        placeholder="Select language"
        fluid
        search
        selection
        className="switchLanguage"
        options={options}
        onChange={(event, optionSelected) => {
          event.preventDefault();
          localStorage.setItem("currentLanguage", optionSelected.value);
          setLang(optionSelected.value);
          firebaseLanguageSetup(optionSelected.value);
        }}
        defaultValue={lang}
      />
    </div>
  );
});
